import $ from "jquery";
import { forms } from "../framework/forms";

function init() {
    setEvents();
}

function setEvents() {
    $("#addAttestationIsGlobalYes").on("change", addAttestationIsGlobalYesChange);
    $("#addAttestationIsGlobalNo").on("change", addAttestationIsGlobalNoChange);
    $("#addattestationsubmitbtn").on("click", addattestationsubmitbtnclick);
}

function addAttestationIsGlobalYesChange() {
    $("#AddAttestationProgramSelect").attr("disabled", true);
    $("#AddAttestationProgramSelect").val("");
}

function addAttestationIsGlobalNoChange() {
    $("#AddAttestationProgramSelect").attr("disabled", false);
}

function addattestationsubmitbtnclick() {
    const $form = $(this).closest("form");
    if ($form.valid()) {
        forms.disableSubmitButton();
        $form.submit();
    }
}

export const addAttestation = {
    init: init
};
